import { inject, observer } from 'mobx-react'
import React from 'react'
import PhotoLayer from './PhotoLayer'
import ElementLayer from './ElementLayer'
import TextLayer from './TextLayer'
import SVGLayer from './SVGLayer'

@inject('workAreaStore', 'elementStore', 'sidebarStore', 'photoStore') @observer
class LayerWrapper extends React.Component {

  constructor(props){
    super(props)
    this.doubleClickTime = null
  }

  getCorrectLayer(layer){
    switch(layer.type){
      case 'photo':
        return <PhotoLayer {...layer} />
      case 'element':
        return <ElementLayer {...layer} />
      case 'text':
        return <TextLayer {...layer} />
      case 'svg':
      case 'svgGroup':
        return <SVGLayer {...layer} isGroup={layer && layer.type === 'svgGroup'} />
      case 'group':
        return <div />
      default:
        return <div />
    }
  }

  checkText(id, e, locked){
    if(locked){
      return
    }
    const { layer: { type, photoType }, workAreaStore, sidebarStore } = this.props
    if(e.detail === 1){
      this.doubleClickTime = setTimeout(() => {
        this.doubleClickTime = null
      }, 250)
    }
    if(e.detail === 1 || (e.detail === 2 && this.doubleClickTime === null)){
      return
    }
    if(type === 'photo' && !photoType) {
      sidebarStore.changeStatus('filters')
    }
    if(type === 'element' || type === 'svg'){
      sidebarStore.changeStatus('color-picker')
    }
    if(type === 'text' && workAreaStore.editingTextId === id && workAreaStore.selectedLayer === id){
      return
    }
    if(type === 'text' && workAreaStore.editingTextId === id && workAreaStore.selectedLayer !== id){
      workAreaStore.selectLayer(id)
      return
    }
    if(type === 'text' && !workAreaStore.editingTextId){
      workAreaStore.selectLayer(id)
      workAreaStore.setTextEditing(id, true)
      sidebarStore.changeStatus("custom-text-style")
      sidebarStore.setTextStyleSlide(true)
      return
    }
    if(type === 'text' && workAreaStore.editingTextId && workAreaStore.editingTextId !== id){
      workAreaStore.unsetAllEditingText()
      workAreaStore.setTextEditing(id, true)
      sidebarStore.changeStatus("custom-text-style")
      sidebarStore.setTextStyleSlide(true)
    }
  }

  selectLayer(id, e){
    const { layer: { type, photoType }, sidebarStore, workAreaStore } = this.props
    let didGroup = false
    const shiftDown = e.shiftKey
    const activeSlide = sidebarStore.getActiveSlide()
    if(activeSlide && activeSlide.id === "background"){
      sidebarStore.closeSidebarSlide()
    }
    if(type === 'svgGroup' && id !== workAreaStore.selectedLayer && sidebarStore.open){
      const layer = workAreaStore.getLayer(id)
      const prevLayer = workAreaStore.getLayer(workAreaStore.selectedLayer)
      let activeIdx = 0
      if(prevLayer && prevLayer.type === 'svgGroup'){
        activeIdx = prevLayer.assetColors.findIndex(({ color }) => color === workAreaStore.editingColor)
        if(activeIdx === -1 || layer.assetColors.length - 1 < activeIdx){
          activeIdx = 0
        }
      }
      this.props.workAreaStore.setEditingColor(false)
      sidebarStore.closeSidebarSlide()
      const newColor = layer.assetColors[activeIdx]
      if(newColor){
        workAreaStore.setEditingColor(newColor.color)
        sidebarStore.changeStatus('svg-color-picker')
      }
    }
    if(type !== 'text'){
      workAreaStore.unsetAllEditingText()
    }
    if(type !== 'group' && !shiftDown){
      workAreaStore.clearExistingGroup()
    }
    if(type !== 'text' && sidebarStore.textStyleOpen){
      sidebarStore.setTextStyleSlide(false)
    }
    if(type === 'text' && id === workAreaStore.editingTextId && id !== workAreaStore.selectedLayer){
      workAreaStore.selectLayer(id)
    }
    if(type === 'text' && id === workAreaStore.editingTextId && id === workAreaStore.selectedLayer){
      return
    }
    if(type === 'text' && workAreaStore.selectedLayer !== id && workAreaStore.editingTextId){
      workAreaStore.unsetAllEditingText()
      sidebarStore.setTextStyleSlide(false)
      setTimeout(() => {
        workAreaStore.selectLayer(id)
      }, 0)
    }    
    const wl = ['sticker', 'gif']
    if((type !== 'photo' || (photoType && wl.includes(photoType))) && activeSlide && activeSlide.id === 'filters'){
      sidebarStore.closeSidebarSlide()
    }
    if(shiftDown && this.props.workAreaStore.selectedLayer && workAreaStore.selectedLayer !== id){
      const { pageIdx, layerIdx } = workAreaStore.findLayerIdx(workAreaStore.selectedLayer)
      if(pageIdx !== -1){
        const prevTarget = workAreaStore.pages[pageIdx].layers[layerIdx]
        if(pageIdx === this.props.pageIndex){
          if(prevTarget.type === 'group'){
            workAreaStore.addToGroup(prevTarget.id, id)
            didGroup = true
          }else{
            workAreaStore.groupLayersById([workAreaStore.selectedLayer, id])
          }
        }else{
          this.props.workAreaStore.selectLayer(id)
        }
      }
    }else{
      this.props.workAreaStore.selectLayer(id)
    }
    if((type === 'element' || type === 'svg') && activeSlide && activeSlide.id !== 'color-picker' && !didGroup){
      sidebarStore.changeStatus('color-picker')
    }
    if(type !== 'photo' && activeSlide && activeSlide.id === 'filters'){
      sidebarStore.closeSidebarSlide()
    }
    if(type !== 'element' && type !== 'svg' && activeSlide && activeSlide.id === 'color-picker' && !didGroup){
      sidebarStore.closeSidebarSlide()
    }
    const activePage = workAreaStore.getActivePage()
    if(type !== 'element' && type !== 'svg' && activePage && activeSlide && activeSlide.id === 'color-picker-page' && !didGroup){
      sidebarStore.closeSidebarSlide()
    }
    /*
    if(activePage && activeItem && activeItem.id === 'color-picker-page'){
      sidebarStore.closeSidebarSlide()
    }
    if(type === 'element' && activeItem && activeItem.id === 'color-picker-page'){
      sidebarStore.changeStatus('color-picker')
    }
    */
  }

  render(){
    const {
      layer,
      layer: { id, xCrop, yCrop, frameHeight, frameWidth, selected, xPos, yPos, originX, originY, locked },
      workAreaStore
    } = this.props
    const layerStyle = workAreaStore.getLayerStyle(layer)
    const xCropValue = !isNaN(xCrop) ? xCrop : 0
    const yCropValue = !isNaN(yCrop) ? yCrop : 0
    const idHash = btoa(id)
    const shouldHide = layer.type === 'text' && workAreaStore.selectedLayer === id && workAreaStore.editingTextId === id
    if(shouldHide){
      return <div />
    }
    const originPos = {}
    if(originX && originY){
      originPos.transformOrigin = `${originX} ${originY}`
    }
    let extraStyle = {}
    let translateStyle = {
      transform: `translate(${xPos}px, 
        ${yPos}px) ${layerStyle.transform ?
        layerStyle.transform : ""}`,
    }
    if(layer.type === 'svg'){
      translateStyle = {
        transform: `translate(${xPos + layer.boxX}px, 
          ${yPos + layer.boxY}px) ${layerStyle.transform ?
          layerStyle.transform : ""}`,
      }
    }
    return (
      <div 
        className={selected ? 'layer selected' : 'layer'}
      >
        <div
          onMouseDown={e => this.selectLayer(id, e)}
          onClick={e => this.checkText(id, e, locked)}
          className='layer-content-wrapper'
          data-id={idHash}
          style={{
            ...layerStyle,
            ...translateStyle,
            ...originPos
            // transform: `translate(${xPos + xCropValue}px, 
            //   ${yPos + yCropValue}px) ${layerStyle.transform ?
            //   layerStyle.transform : ""}`,
          }}
        >
          <div className='layer-content'
            style={{
              height: frameHeight,
              width: frameWidth,
              transform: `translate(${layer.type === 'svg' ? -layer.boxX : xCropValue}px, ${layer.type === 'svg' ? -layer.boxY : yCropValue}px)`,
              position: 'absolute',
              ...extraStyle
            }}
          >
            {this.getCorrectLayer(layer)}
          </div>
        </div>
      </div>
    )
  }

}

export default LayerWrapper